import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["colorKey", "selected", "size", "title", "children"];
// From https://git.hubteam.com/HubSpot/feedback-ui/blob/7f78d640a080a2cdcc804245d3529165810eee58/feedback-shared-ui/static/js/ratings/internal/CsatButton.js

import { memo } from 'react';
import styled, { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const borderRatio = 0.09;
const getWrapperStyle = ({
  color,
  size
}) => {
  const bSize = Math.ceil(borderRatio * size);
  return `
    padding: ${bSize}px;
    border-width: ${bSize}px;
    border-radius: 50%;
    border-style: solid;
    border-color: ${color};
    transition: border-color linear 0.2s;
  `;
};
const selectedStyle = ({
  selected
}) => {
  return selected ? '' : `&:not(:hover) {
        border-color: transparent;
      }`;
};
const Wrapper = styled.span.withConfig({
  displayName: "CsatButton__Wrapper",
  componentId: "b35i4l-0"
})(["cursor:pointer;display:inline-block;", " ", ""], getWrapperStyle, selectedStyle);
const StyledSvg = styled.svg.withConfig({
  displayName: "CsatButton__StyledSvg",
  componentId: "b35i4l-1"
})(["display:block;"]);
const CsatButton = /*#__PURE__*/memo(_ref => {
  let {
      colorKey,
      selected = false,
      size,
      title,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const svgSize = size - size * borderRatio * 2;
  const color = theme.color[colorKey];
  return /*#__PURE__*/_jsx(Wrapper, Object.assign({
    selected: selected,
    color: color,
    size: size
  }, rest, {
    role: "button",
    children: /*#__PURE__*/_jsxs(StyledSvg, {
      xmlns: "http://www.w3.org/2000/svg",
      width: svgSize,
      height: svgSize,
      viewBox: "0 0 54 54",
      children: [/*#__PURE__*/_jsx("title", {
        children: title
      }), /*#__PURE__*/_jsx("g", {
        id: "Connecting-Feedback-CSAT-survey-to-chat",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: children
      })]
    })
  }));
});
export default CsatButton;